module.exports = __webpack_public_path__ + "img/fullscreen.ba7ff2b6.png";